module.exports = __webpack_public_path__ + "img/kitten.66c717dc.jpg";